/**
 * Whether the user has requested reduced motion via the OS/browser setting.
 * Centralized so the globe renderer and the drawer share one definition (and one
 * `matchMedia` guard for environments without it).
 */
export function prefersReducedMotion(): boolean {
  return (
    typeof window.matchMedia === 'function' &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches
  )
}
